import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";

export interface IConsultingConfirmationRequestDatatableRowFormMeta {
  TC: FormInputMeta,
  processingDate: FormInputMeta,  
  acquirerReferenceNumber: FormInputMeta,
  accountNumber: FormInputMeta,
  amount: FormInputMeta,
  currency: FormInputMeta,
  merchant: FormInputMeta,
  reason: FormInputMeta,
  //
  reasonCode: FormInputMeta,
  //
  schema: any,
}

const ConsultingConfirmationRequestDatatableRowFormMeta = {} as IConsultingConfirmationRequestDatatableRowFormMeta;

ConsultingConfirmationRequestDatatableRowFormMeta.TC = {
  name: 'TC',
  type: 'text',
  label: 'TC',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultingConfirmationRequestDatatableRowFormMeta.processingDate = {
  name: 'processingDate',
  type: 'date',
  label: 'Date de traitement',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultingConfirmationRequestDatatableRowFormMeta.acquirerReferenceNumber = {
  name: 'acquirerReferenceNumber',
  type: 'text',
  label: 'Numero reference acquéreur',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultingConfirmationRequestDatatableRowFormMeta.accountNumber = {
  name: 'accountNumber',
  type: 'text',
  label: 'Numero compte',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultingConfirmationRequestDatatableRowFormMeta.amount = {
  name: 'amount',
  type: 'text',
  label: 'Montant',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultingConfirmationRequestDatatableRowFormMeta.currency = {
  name: 'currency',
  type: 'text',
  label: 'Devise',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultingConfirmationRequestDatatableRowFormMeta.merchant = {
  name: 'merchant',
  type: 'text',
  label: 'Commercant',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultingConfirmationRequestDatatableRowFormMeta.reason = {
  name: 'reason',
  type: 'text',
  label: 'Motif',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
ConsultingConfirmationRequestDatatableRowFormMeta.reasonCode = {
  name: 'reasonCode',
  type: 'text',
  label: 'Code Motif',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};


ConsultingConfirmationRequestDatatableRowFormMeta.schema = yup.object().shape(getValidationSchema(ConsultingConfirmationRequestDatatableRowFormMeta));

export default ConsultingConfirmationRequestDatatableRowFormMeta;
